import Questions from './Questions.tsx';

export default Questions;